module.exports = __webpack_public_path__ + "img/symbol_9.9ebc9d0d.png";